import Model from 'src/app/common/model';
import QueryParamsModel from './queryParams.model';
import CultureCategoryModel from './cultureCategory.model';
import SpeciesTypeModel from './speciesType.model';

export default class QpRangesModel extends Model {
  qp: QueryParamsModel;
  cultureCategory: CultureCategoryModel;
  speciesType: SpeciesTypeModel;
  min_acc_range: string;
  max_acc_range: string;
  min_des_range?: number;
  max_des_range?: number;
  min_stress_range?: number;
  max_stress_range?: number;
  qp_id: number;
  culture_category_id: number;
  species_type_id: number;

  constructor() {
    super();
  }
}
